<ng-container *ngIf="orderFacade.hasError$ | async">
	<ng-container *ngIf="orderFacade.error$ | async as error">
		<div class="alert alert--error">
			<mat-icon svgIcon="mdi-alert-circle-outline" class="alert--icon"></mat-icon>
			<div class="alert--text"><b>Bestellung:</b>&nbsp;{{ error }}</div>
		</div>
	</ng-container>
</ng-container>
